import React, { useEffect, useState } from "react";
import LoadingSpinner from "Components/UI/LoadingSpinner";
import { useTableSearch } from "core/Operations/useTableSearch";
import Error404 from "MainPages/ErrorPages/error404";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { Edit, PlusCircle, Upload } from "react-feather";
import { Link } from "react-router-dom";
import { all_routes } from "Router/all_routes";
import { useSelector } from "react-redux";
import { loggedInUser } from "core/redux/slice/authSlice";
import TableTop from "Components/UI/TableTop";
import { useGetEmpAdditionsQuery } from "AppQuries/payroll/addition/emp-addition";
import Datatable from "core/pagination/datatable";
import { useGetAllDepartmentQuery } from "AppQuries/master/Department/get-all-departments";
import { useGetAdditionsQuery } from "AppQuries/payroll/addition/get-all-additions";
import { format, set, startOfMonth, endOfMonth } from "date-fns";
import { DatePicker, Select } from "antd";
import { useGetEmployeeQuery } from "AppQuries/employee/employee_list";
import dayjs from "dayjs";
import { useGetEmpAdditionDeductionQuery } from "AppQuries/payroll/emp-allowance-deduction";
import { useGetDeductionsQuery } from "AppQuries/payroll/deduction/get-all-deduction";
import ReportTools from "Components/UI/ReportTools";
import { toast } from "core/Operations/toast";
import { hasPermission } from "core/Operations/checkPermission";
import { IoReloadCircle } from "react-icons/io5";
import Can from "core/Operations/Can";
import { accessCodes } from "core/json/accessCode";
const { RangePicker } = DatePicker;
const typeOptions = [
  {
    id: 1,
    label: "Addition",
    value: "Addition",
  },
  {
    id: 2,
    label: "Deduction",
    value: "Deduction",
  },
];
const EmployeeAllowanceDeduction = () => {
  const userData = useSelector(loggedInUser);

  const [isMount, setIsMount] = useState(false);
  const [queryParams, setQueryParams] = useState({
    employeeCode: 0,
    departmentCode: 0,
    type: "Addition",
    typeCode: 0,
    fromDate: format(startOfMonth(new Date()), "yyyy-MM-dd"),
    toDate: format(endOfMonth(new Date()), "yyyy-MM-dd"),
  });

  const {
    data,
    isFetching,
    isError,
    error,
    refetch: getEmpAllowance,
  } = useGetEmpAdditionDeductionQuery(
    {
      companyCode: userData?.companyCode,
      locationCode: userData?.selectedLocationCode,
      ...queryParams,
    },
    {
      enabled: Boolean(
        queryParams.employeeCode &&
          queryParams.departmentCode &&
          userData?.companyCode
      ),
    }
    // { skip: true }
  );

  const updateQueryParams = (key, value) => {
    setQueryParams((prev) => ({ ...prev, [key]: value }));
  };

  const allowanceData = Array.isArray(data)
    ? data.map((d, _id) => {
        const effectiveDateFrom = d.effectiveDateFrom
          ? format(new Date(d.effectiveDateFrom), "dd-MM-yyyy")
          : "";
        const effectiveDateTo = d.effectiveDateTo
          ? format(new Date(d.effectiveDateTo), "dd-MM-yyyy")
          : "";

        return {
          ...d,
          id: _id,
          effectiveDateFrom,
          effectiveDateTo,
        };
      })
    : [];

  const { data: employees, refetch: getEmployee } = useGetEmployeeQuery({
    companyCode: userData?.companyCode,
    locationCode: userData?.selectedLocationCode,
    departmentCode: queryParams?.departmentCode,
    isAll: false,
  });
  const { data: departments } = useGetAllDepartmentQuery({
    companyCode: userData?.companyCode,
    isTrue: true,
  });
  const { data: allowance } = useGetAdditionsQuery({
    companyCode: userData?.companyCode,
  });

  const employeeOptions = Array.isArray(employees)
    ? employees
        ?.filter((d) => d.isActive)
        .map((o) => ({
          id: o.employeeCode,
          label: `${o.uniqueId}-${o.fullName}`,
          value: o.employeeCode,
        }))
    : [];

  const departmentOptions = Array.isArray(departments?.data)
    ? departments?.data
        .filter((d) => d.isActive)
        .map((o) => ({
          id: o.code,
          label: o.description,
          value: o.code,
        }))
    : [];
  const allowanceOptions = Array.isArray(allowance?.data)
    ? allowance?.data
        // .filter((d) => d.isActive)
        .map((o) => ({
          id: o.code,
          label: o.description,
          value: o.code,
        }))
    : [];

  const { data: deductions } = useGetDeductionsQuery({
    companyCode: userData?.companyCode,
    isTrue: true,
  });
  const deductionOptions = Array.isArray(deductions?.data)
    ? deductions?.data
        // .filter((d) => d.isActive)
        .map((o) => ({
          id: o.code,
          label: o.description,
          value: o.code,
        }))
    : [];
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const columns = [
    {
      title: "Emp Code",
      dataIndex: "uniqueID",
      sorter: (a, b) => a.uniqueID.length - b.uniqueID.length,
    },
    {
      title: "Employee Name",
      dataIndex: "employeeName",
      sorter: (a, b) => a.employeeName.length - b.employeeName.length,
      render: (text, record) => (
        <Link
          to={`${all_routes.employee}${all_routes.employee_view}/${record.employeeCode}`}
        >
          {text}
        </Link>
      ),
    },
    {
      title: "Description",
      dataIndex: "description",
      // sorter: (a, b) => a.description.length - b.description.length,
    },

    // {
    //   title: "have CPF",
    //   dataIndex: "haveCPF",
    //   sorter: (a, b) => a.haveCPF.length - b.haveCPF.length,
    //   render: (text, record) => (
    //     <>
    //       {text === true && <div className="bg-lightgreen">Yes</div>}
    //       {text === false && <div className="bg-lightred">No</div>}
    //     </>
    //   ),
    // },
    {
      title: "Amount",
      dataIndex: "amount",
      // sorter: (a, b) => a.amount.length - b.amount.length,
    },
    {
      title: "Start Date",
      dataIndex: "effectiveDateFrom",
      // sorter: (a, b) => a.effectiveDateFrom.length - b.effectiveDateFrom.length,
    },

    {
      title: "End Date",
      dataIndex: "effectiveDateTo",
      // sorter: (a, b) => a.effectiveDateTo.length - b.effectiveDateTo.length,
    },
    {
      title: "Action",
      dataIndex: "action",
      className: "action-table-data",
      render: (text, record) => (
        <div className="edit-delete-action">
          <div className="input-block add-lists"></div>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="edit-tooltip">Edit</Tooltip>}
          >
            {record.isEditable ? (
              <Can
                accessModule={accessCodes.human_resources}
                accessCode={accessCodes.allowances_deductions}
                accessType="haveEdit"
              >
                <Link
                  className="me-2 p-2"
                  to={`${all_routes.edit_emp_allowance_deduction}/${
                    record.allowanceCode ?? ""
                  }?type=${record.type ?? ""}&typeCode=${record.code ?? ""}`}
                >
                  <Edit className="feather-edit" />
                </Link>
              </Can>
            ) : (
              <Link
                className="me-2 p-2"
                // to="#"
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  toast.warning("Payroll was generate for this item");
                }}
              >
                <Edit className="feather-edit" />
              </Link>
            )}
          </OverlayTrigger>
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (isMount) getEmployee();

    setIsMount(true);
  }, [queryParams?.departmentCode]);

  const searchColumns = columns.map((column, index) => column.dataIndex);
  const { searchValue, setSearchValue, filteredData } = useTableSearch(
    allowanceData,
    searchColumns
  );
  //   if (isFetching) return <LoadingSpinner />;
  //   if (isError) return <Error404 error={error} />;
  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Allowance / Deduction Management</h4>
                <h6>Manage Employee Allowance / Deduction Details</h6>
              </div>
            </div>
            <div className="page-btn">
              <ReportTools
                columns={columns}
                data={filteredData}
                fileName="Employee Allowance And Deduction"
                isExcel={true}
                isPdf={true}
                pdfTheme="striped"
                refresh={getEmpAllowance}
              />
            </div>
            <>
              <Can
                accessModule={accessCodes.human_resources}
                accessCode={accessCodes.allowances_deductions}
                accessType="haveAdd"
              >
                <div className="page-btn">
                  <Link
                    to={`${all_routes.add_emp_allowance_deduction}`}
                    f
                    className="btn btn-added"
                  >
                    <PlusCircle className="me-2" />
                    Add New
                  </Link>
                </div>
                &nbsp;
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id="add-new-tooltip">Import</Tooltip>}
                  >
                    <Link
                      to={`${all_routes.import_emp_allowance_deduction}`}
                      className="btn btn-secondary"
                      // style={{ height: "30px" }}
                    >
                      <Upload className="me-2" />
                      Import Data
                    </Link>
                  </OverlayTrigger>
                </div>
                <div className="page-btn">
                  <OverlayTrigger
                    placement="top"
                    overlay={
                      <Tooltip id="add-new-tooltip">Generate Data</Tooltip>
                    }
                  >
                    <Link
                      to={`${all_routes.generate_emp_allowance_deduction}`}
                      className="btn btn-secondary"
                      // style={{ height: "30px" }}
                    >
                      <IoReloadCircle className="me-2" />
                      Generate Data
                    </Link>
                  </OverlayTrigger>
                </div>
              </Can>
            </>
          </div>

          <div className="card table-list-card border-0">
            <div className="card-body">
              <TableTop
                onSearch={setSearchValue}
                toggleFilterVisibility={toggleFilterVisibility}
                isFilterVisible={isFilterVisible}
                showToggle={true}
              />
              <div className="card-body pb-0">
                <div className="form-row row">
                  <div className="col-lg-3 col-sm-6 col-12 mb-3">
                    <label className="form-label">Start Date – End Date</label>
                    <div className="form-group">
                      <RangePicker
                        className="form-control"
                        style={{ display: "flex" }}
                        onChange={(dates, dateStrings) => {
                          if (dates) {
                            updateQueryParams("fromDate", dateStrings[0]);
                            updateQueryParams("toDate", dateStrings[1]);
                          }
                        }}
                        defaultValue={[
                          dayjs(queryParams.fromDate, "YYYY-MM-DD"),
                          dayjs(queryParams.toDate, "YYYY-MM-DD"),
                        ]}
                        dateFormat="YYYY-MM-DD"
                        getPopupContainer={(triggerNode) =>
                          triggerNode.parentNode
                        }
                        // disabledDate={disabledDate}
                      />
                    </div>
                  </div>

                  <div className="col-lg-2 col-sm-6 col-12 mb-3">
                    <div className="form-group">
                      <label className="form-label">Department</label>
                      <Select
                        className="form-control"
                        options={departmentOptions}
                        placeholder="Department"
                        value={departmentOptions.find(
                          (option) =>
                            option.value === queryParams.departmentCode
                        )}
                        onChange={(e) => {
                          updateQueryParams("departmentCode", e || 0);
                        }}
                        allowClear
                        showSearch
                        optionFilterProp="label"
                        variant="borderless"
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>

                  <div className="col-lg-2 col-sm-6 col-12 mb-3">
                    <div className="form-group">
                      <label className="form-label">Employee</label>
                      <Select
                        className="form-control"
                        options={employeeOptions}
                        placeholder="Select Employee"
                        value={
                          employeeOptions.find(
                            (option) =>
                              option.value === queryParams.employeeCode
                          ) || ""
                        }
                        onChange={(e) => {
                          updateQueryParams("employeeCode", e || 0);
                        }}
                        allowClear
                        showSearch
                        optionFilterProp="label"
                        variant="borderless"
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>

                  <div className="col-lg-2 col-sm-6 col-12 mb-3">
                    <div className="form-group">
                      <label className="form-label">Type</label>
                      <Select
                        className="form-control"
                        options={typeOptions}
                        placeholder="Allowance"
                        value={
                          typeOptions.find(
                            (option) => option.value === queryParams.type
                          ) || ""
                        }
                        onChange={(e) => {
                          updateQueryParams("type", e || "");
                          updateQueryParams(
                            "typeCode",
                            e
                              ? queryParams.type === "Addition"
                                ? allowanceOptions.find(
                                    (option) => option.value === e
                                  )?.value || 0
                                : queryParams.type === "Deduction"
                                ? deductionOptions.find(
                                    (option) => option.value === e
                                  )?.value || 0
                                : 0
                              : 0
                          );
                        }}
                        allowClear
                        showSearch
                        optionFilterProp="label"
                        variant="borderless"
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>

                  <div className="col-lg-2 col-sm-6 col-12 mb-3">
                    <div className="form-group">
                      <label className="form-label">Type Name</label>
                      <Select
                        className="form-control"
                        options={
                          queryParams.type === "Addition"
                            ? allowanceOptions
                            : queryParams.type === "Deduction"
                            ? deductionOptions
                            : []
                        }
                        placeholder="Select Type Name"
                        value={
                          (queryParams.type === "Addition"
                            ? allowanceOptions
                            : queryParams.type === "Deduction"
                            ? deductionOptions
                            : []
                          ).find(
                            (option) => option.value === queryParams.typeCode
                          ) || ""
                        }
                        onChange={(e) => {
                          updateQueryParams("typeCode", e || 0);
                        }}
                        allowClear
                        showSearch
                        optionFilterProp="label"
                        variant="borderless"
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>

                  {/* <div className="col-lg-2 col-sm-6 col-12 mb-3">
                        <div className="form-group">
                          <label className="form-label">Type</label>
                          <Select
                            className="form-control"
                            options={typeOptions}
                            placeholder="Allowance"
                            value={
                              typeOptions.find(
                                (option) => option.value === queryParams.type
                              ) || ""
                            }
                            onChange={(e) => {
                              updateQueryParams("type", e || "");
                              updateQueryParams("typeCode", 0);
                            }}
                            isClearable
                          />
                        </div>
                      </div>

                      <div className="col-lg-2 col-sm-6 col-12 mb-3">
                        <div className="form-group">
                          <label className="form-label">Type Name</label>
                          <Select
                            className="form-control"
                            options={
                              queryParams.type === "Addition"
                                ? allowanceOptions
                                : queryParams.type === "Deduction"
                                ? deductionOptions
                                : []
                            }
                            placeholder="Select Type Name"
                            value={
                              allowanceOptions.find(
                                (option) =>
                                  option.value === queryParams.typeCode
                              ) || ""
                            }
                            onChange={(e) => {
                              updateQueryParams("typeCode", e || 0);
                            }}
                            isClearable
                          />
                        </div>
                      </div> */}

                  <div className="col-lg-1 col-sm-6 col-12">
                    <div className="input-blocks">
                      <label className="form-label">&nbsp;</label>
                      <Link
                        className="btn btn-filters ms-auto"
                        onClick={getEmpAllowance}
                        type="button"
                      >
                        <i data-feather="search" className="feather-search" />
                        <>Filter</>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div className="table-responsive">
                <Datatable
                  columns={columns}
                  dataSource={filteredData}
                  rowKey={(record) => record.key}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default React.memo(EmployeeAllowanceDeduction);
